import { isInstanceOf } from './is-instance-of.js';

export function isNodeInstance(value: unknown): value is Node {
  return isInstanceOf(Node, value);
}
